<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>肺炎建模</el-breadcrumb-item>
      <el-breadcrumb-item>任务列表</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card v-loading="wholeloading">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-input
            size="small"
            placeholder="搜索姓名"
            clearable
            v-model="queryInfo.query"
            @clear="handleCurrentChange(1)"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="handleCurrentChange(1)"
            ></el-button>
          </el-input>
        </el-col>
        <el-col :span="8">
          <el-button @click="multiBtnClick()" size="mini" type="primary" v-if="!btnOptional">多期对比</el-button>
          <el-button @click="multiViewClick()" size="mini" type="primary" v-if="btnOptional">阅片诊断</el-button>
          <el-button @click="multiChartClick()" size="mini" type="primary" v-if="btnOptional">图表分析</el-button>
          <el-button @click="btnOptional = false;" size="mini"  v-if="btnOptional">取消</el-button>
        </el-col>
      </el-row>

      <el-table
        ref="taskTable"
        :data="tasklist"
        stripe
        border
        style="width: 100%"
        v-loading="loading"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          v-if="btnOptional">
        </el-table-column>
        <el-table-column
          prop="taskid"
          label="任务编号"
          width="80"
        ></el-table-column>
        <el-table-column
          prop="dataid"
          label="数据编号"
          width="80"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          min-width="150"
        ></el-table-column>
        <el-table-column
          prop="gender"
          label="性别"
          min-width="50"
        ></el-table-column>
        <el-table-column
          prop="age"
          label="年龄"
          min-width="50"
        ></el-table-column>
        <el-table-column
          prop="scantime"
          label="CT扫描时间"
          width="140"
        ></el-table-column>
        <el-table-column
          prop="createtime"
          label="任务创建时间"
          width="140"
        ></el-table-column>

        <el-table-column label="AI建模" width="100">
          <template v-slot="scope">
            <span v-if="scope.row.aistatus === '2'">已完成</span>
            <span v-if="scope.row.aistatus === '1'">正在计算</span>
            <span v-if="scope.row.aistatus === '0'">
              <el-button
                @click="startAi(scope.row.taskid)"
                size="mini"
                type="primary"
              >
                运行
              </el-button>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="完成时间" width="140">
          <template v-slot="scope">
            <span v-if="scope.row.aistatus === '2'">{{
              scope.row.aifinishtime
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="肺炎(ml)/肺部(ml)/占比(%)" width="200">
          <template v-slot="scope">
            <span v-if="scope.row.inflamvol !== null">{{scope.row.inflamvol}} / {{scope.row.lungvol}} / {{scope.row.inflamratio}}</span>
          </template>
        </el-table-column>
        <el-table-column label="下载模型" width="100">
          <template v-slot="scope">
            <el-button
              v-if="scope.row.aistatus === '2'"
              @click="downloadSTL(scope.row.taskid)"
              size="mini"
              type="primary"
            >
              <i class="el-icon-download" style="font-size: 12px"></i>
            </el-button>
          </template>
        </el-table-column>
        
        <el-table-column label="三维预览" width="100">
          <template v-slot="scope">
            
              <el-button v-if="scope.row.aistatus === '2'" @click="goto3D(scope.row.taskid)"  size="mini" type="primary">预览</el-button>

          </template>
        </el-table-column>
        <el-table-column label="CT阅片" width="100">
          <template v-slot="scope">
              <el-button
              v-if="scope.row.aistatus === '2'"
                @click="gotoViewer(scope.row.taskid)"
                size="mini"
                type="primary"
                >阅片</el-button
              >
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 15, 20]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      ></el-pagination>


      <el-dialog title="炎症分析图" :visible.sync="chartVisible" width="50%" @open="loadEcharts()">
        <div id="myChart" :style="{width: '100%', height: '400px'}"></div>
      </el-dialog>
      
    </el-card>

    
  </div>
</template>

<script>

export default {
  data() {
    return {
      wholeloading: false,
      loading: false,
      queryInfo: {
        query: "",
        pagenum: 1,
        pagesize: 10,
      },
      tasklist: [],
      total: 0,
      chartVisible: false,
      btnOptional: false,
      selectTasks:[],
      chartInfo:[]
    };
  },
  methods: {
    async goto3D(taskid) {
      console.log(taskid)
      const {data} = await this.$http.get("/getInflamSTLinfo/"+taskid)
      if (data.status===100){
        let param = data.data;
        var info = window.btoa(JSON.stringify(param));
        window.open("/STLViewer-Inflam/model.html?info="+info);
       
      }
      
    },
    gotoViewer(taskid) {
      this.$router.push("/inflamViewer?id=" + taskid);
    },
    async getDataList() {
      this.loading = true;
      const { data } = await this.$http.post("/getTaskList", this.queryInfo);
      if (data.status === 100) {
        this.tasklist = data.data.list;
        this.total = data.data.total;
      }
      this.loading = false;
    },
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize;
      this.queryInfo.pagenum = 1;
      this.getDataList();
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pagenum = newPage;
      this.getDataList();
    },
    downloadSTL(taskid) {
      let baseurl = this.$http.defaults.baseURL;
      window.location = baseurl + "downloadSTL/" + taskid;
      this.$message({ type: "success", message: "正在生成压缩包" });
    },
    startAi(taskid) {

      this.$confirm("是否确定运行?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(async () => {
        this.loading = true;
        const { data } = await this.$http.post(
          "/submitAiTask/" + taskid
        );
        this.loading = false;
        if (data.status === 100) {
          this.$message({ type: "success", message: "已提交" });
          this.getDataList();
        }
      });
    },
    multiBtnClick(){
      this.btnOptional = true;
      this.selectTasks=[];
      this.$refs.taskTable.clearSelection();
    },
    handleSelectionChange(val) {
      this.selectTasks = val;
      console.log(this.selectTasks);
      
    },
    multiViewClick(){
      if (this.selectTasks.length === 0) return;
      let taskids = [];
      for (let i=0;i<this.selectTasks.length;i++){
        taskids.push(this.selectTasks[i].taskid);
      }
      var info = window.btoa(JSON.stringify(taskids));
      this.$router.push("/inflamMultiViewer?taskids=" + info);
    },
    async multiChartClick() {
      if (this.selectTasks.length === 0) return;
      let taskids = [];
      for (let i=0;i<this.selectTasks.length;i++){
          taskids.push(this.selectTasks[i].taskid);
      }
      const {data} = await this.$http.post("getChartInfo",{taskids:taskids});
      if (data.status === 100){
        this.chartInfo = data.data;
        this.chartVisible = true;
      }

      
      // this.drawLine();
    },
    loadEcharts(){
      this.$nextTick(() => {
          this.drawLine()
      })
    },
    drawLine(){
        let volumes = [];
        let ratios = [];
        let times = [];

        for (let i=0;i<this.chartInfo.length;i++){
          volumes.push(this.chartInfo[i].inflamVol);
          ratios.push(this.chartInfo[i].inflamRatio);
          times.push(this.chartInfo[i].scantime);
        }
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('myChart'))
        let option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              crossStyle: {
                color: '#999'
              }
            }
          },
          toolbox: {
            feature: {
              dataView: { show: true, readOnly: false },
              magicType: { show: true, type: ['line', 'bar'] },
              restore: { show: true },
              saveAsImage: { show: true }
            }
          },
          legend: {
            data: ['肺炎体积', '炎症比例']
          },
          xAxis: [
            {
              type: 'category',
              data: times,
              axisPointer: {
                type: 'shadow'
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              name: '肺炎体积',
              // min: 0,
              // max: 250,
              // interval: 50,
              axisLabel: {
                formatter: '{value} ml'
              }
            },
            {
              type: 'value',
              name: '炎症比例',
              // min: 0,
              // max: 25,
              // interval: 5,
              axisLabel: {
                formatter: '{value} %'
              }
            }
          ],
          series: [
            {
              name: '肺炎体积',
              type: 'bar',
              barWidth:30,
              data: volumes
            },
            {
              name: '炎症比例',
              type: 'line',
              yAxisIndex: 1,
              barWidth:30,
              data: ratios
            }
          ]
        };

        // 绘制图表
        myChart.setOption(option);
    }
  },
  created() {
    this.getDataList();
  },
  beforeDestroy() {
    console.log("before destory");
    clearInterval(this.timer);
  },
};
</script>

<style lang="less" scoped>
.el-cascader {
  width: 100%;
}
.cardiacCheckbox {
  display: block;
  margin-left: 20px;
  margin-top: 10px;
}
</style>
